import { IChartSeries } from '@mais-retorno-front/models/chart-serie';
import { IAssetQuotes } from '../interfaces';

export const createComparisonDrawDownSerie = (
  assetQuotes: IAssetQuotes[]
): IChartSeries[] => {
  const serie = assetQuotes.map((asset) => {
    let peak = 0;

    return {
      fillOpacity: 0.2,
      type: 'area',
      id: asset.id,
      data: asset.quotes.map(({ d, c }) => {
        const period = d;

        if (peak === 0) {
          peak = c;
        }

        const under = (c / peak - 1) * 100;

        if (c > peak) {
          peak = c;
        }

        return under < 0 ? [period, under] : [period, 0.0];
      }),
      name: asset.nicename,
      color: asset.color,
    };
  });

  return serie as IChartSeries[];
};
